<template>
  <div id="app">
    <!-- <transition :name="nav_action"> -->
    <!-- <keep-alive>
      <router-view v-if="$route.meta.keepAlive" />
    </keep-alive> -->

    <!-- <router-view v-if="!$route.meta.keepAlive"/> -->
    <router-view/>
    <div id="Cover" v-if="isCover&&showCover">
      <img id="CoverImg" src="./assets/roate.png" alt />
      <p class="CoverTip">为了您的良好体验，在非课程内容页面下，请您将手机/平板竖屏操作</p>
    </div>
    <!-- </transition> -->
    <!-- <v-tab-bar></v-tab-bar> -->
  </div>
</template>

<script>
import {
  getCode,
  getSign,
  initUserData,
  GetOnlineTime,
  UpdataUserInfo
} from "./service";
import { IsPC } from "./utils/index";
export default {
  name: "App",
  data() {
    return {
      nav_action: "",
      hideNav: false,
      token: "",
      isCover: false,
      mukey: false,
      showCover: true,
      onlineTimer: null  // 在线时长计时器
    };
  },
  watch: {
    $route(to, from) {
      if (
        to.path != "dgkh" ||
        to.path != "kcxq" ||
        to.path != "announcementDetail"
      ) {
        this.renderResize();
      }
    }
  },
  methods: {
    // 判断是pc端还是移动端
    renderResize() {
      // 判断横竖屏
      if (
        IsPC() ||
        window.location.href.indexOf("kcxq?courseId") != -1 ||
        window.location.href.indexOf("courseInfo?courseId") != -1 ||
        window.location.href.indexOf("dgkh?courseId") != -1 ||
        window.location.href.indexOf("announcementDetail") != -1
      ) {
        //go to pc
        // console.log("竖屏");
        this.isCover = false;
        this.mukey = !this.mukey;
      } else {
        // go to 手机
        let width = document.documentElement.clientWidth;
        let height = document.documentElement.clientHeight;
        if (width > height && !IsPC()) {
          // alert('横屏')
          console.log("横屏");
          this.isCover = true;
          this.mukey = !this.mukey;
        } else if (width < height && !IsPC()){
          console.log("竖屏");
          this.isCover = false;
          this.mukey = !this.mukey;
        }
      }
    },
    // 获取token
    getToken() {
      var a = document.createElement("A");
      a.setAttribute(
        "href",
        "https://open.weixin.qq.com/connect/oauth2/authorize?appid=ww5f1917dc1e451a6e&redirect_uri=http%3a%2f%2fdudao.tianwangwatch.cn&response_type=code&scope=snsapi_base&agentid=1000004#wechat_redirect"
      );
      var evt = document.createEvent("MouseEvents");
      evt.initEvent("click", true, false);
      a.dispatchEvent(evt);
    }
  },
  mounted() {
    // 监听resize方法
    window.addEventListener("resize", this.renderResize, false);
    // 微信sdkJs注入
    getSign(window.location.href.split("#")[0]).then(data => {
      wx.config({
        // beta: true,// 必须这么写，否则wx.invoke调用形式的jsapi会有问题
        // debug: true, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
        appId: "ww5f1917dc1e451a6e", // 必填，企业微信的corpID
        timestamp: data.data.data.timestamp, // 必填，生成签名的时间戳
        nonceStr: data.data.data.noncestr, // 必填，生成签名的随机串
        signature: data.data.data.signature, // 必填，签名，见 附录-JS-SDK使用权限签名算法
        jsApiList: ["hideOptionMenu"] // 必填，需要使用的JS接口列表，凡是要调用的接口都需要传进来
      });
      wx.ready(function() {
        // config信息验证后会执行ready方法，所有接口调用都必须在config接口获得结果之后，config是一个客户端的异步操作，所以如果需要在页面加载时就调用相关接口，则须把相关接口放在ready函数中调用来确保正确执行。对于用户触发时才调用的接口，则可以直接调用，不需要放在ready函数中。
        wx.hideOptionMenu();
      });
      wx.error(function(error) {
        console.log("error", error);
      });
    });
  },
  beforeDestroy() {
    clearInterval(this.onlineTimer);
    this.onlineTimer = null;
    // 移除监听
    window.removeEventListener("resize", this.renderResize, false);
    window.onbeforeunload = onbeforeunload_handler;
    // function onbeforeunload_handler() {
    //   var OutTime = Date.parse(new Date());
    //   window.sessionStorage.setItem("outTime", OutTime);
    //   var Time =
    //     (OutTime - Number(window.localStorage.getItem("startTime"))) /
    //     1000 /
    //     60;
    //   var params = {
    //     min: Time,
    //     id: this.storeData.userInfo.userId
    //   };
    //   GetOnlineTime(params).then(({ data }) => {
    //     console.log(data);
    //   });
    // }
    // var OutTime = Date.parse(new Date());
    //   // window.localStorage.setItem("outTime", OutTime);
    //   var Time =
    //   Math.round((OutTime - Number(window.localStorage.getItem("startTime"))) /
    //     1000 /
    //     60);
    //     $.ajax({
    //       type: 'POST',
    //       url: 'https://dudao.tianwangwatch.cn/twb_api/auth/recordTimeLen',
    //       async: false,
    //       headers:{
    //         token: window.localStorage.getItem('_t')
    //       },
    //       data: {
    //         min: Time
    //       },
    //       success: function (res){
    //         console.log(res);
            
    //       },
    //       dataType: 'json'
    //     });
  },
  created() {
    var that = this;
    /**
     * 不走授权页面
     */
    // if(!sessionStorage.getItem("isLogin")){
    //   this.getToken();
    //   sessionStorage.setItem("isLogin", true);
    // }

    
    // if ((!window.sessionStorage.getItem("isLogin") && !window.sessionStorage.getItem("code")) || (!window.sessionStorage.getItem("isLogin") && window.location.href.indexOf("code") == -1)) {
    //   this.getToken();
    //   window.sessionStorage.setItem("isLogin", true);
    // } else if(window.sessionStorage.getItem("isLogin")&&window.sessionStorage.getItem("code")&&window.sessionStorage.getItem("_t")){
    //    this.storeData.token = window.sessionStorage.getItem("_t");
    // }else{
    //   new Promise((resolve, reject) => {
    //     var getQueryString = function(name) {
    //       var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
    //       var r = window.location.search.substr(1).match(reg);
    //       if (r != null) return unescape(r[2]);
    //       return null;
    //     };
    //     var code = getQueryString("code");
    //     if (code) {
    //       var xhr = window.XMLHttpRequest
    //         ? new XMLHttpRequest()
    //         : ActiveXObject("microsoft.XMLHttp");
    //       xhr.open(
    //         "post",
    //         `https://dudao.tianwangwatch.cn/twb_api/auth/OAuthNotify?code=${code}`,
    //         true
    //       ); // xhr.setRequestHeader("Content-type","application/x-www-form-urlencoded");
    //       xhr.send();
    //       xhr.onreadystatechange = function() {
    //         if (xhr.readyState == 4) {
    //           if (xhr.status == 200) {
    //             var data = xhr.responseText;
    //             if (JSON.parse(data).code == 200) {
    //               that.storeData.token = JSON.parse(data).data;
    //               window.sessionStorage.setItem("_t", JSON.parse(data).data);
    //               var StartTime = Date.parse(new Date());
    //               window.sessionStorage.setItem("code", code);
    //               window.sessionStorage.setItem("startTime", StartTime);
    //               resolve();
    //               // window.location.href = 'http://dudao.tianwangwatch.cn'
    //             } 
    //             // else {
    //             //   window.location.href = 'http://dudao.tianwangwatch.cn/OAuth';
    //             // }
    //             //                     		return data;
    //           }
    //         }
    //       };
    //     }
    //   }).then(() => {
    //     initUserData(this.storeData.token)
    //       .then(({ data }) => {
    //         if (data.code === 501) {
    //           window.sessionStorage.removeItem("_t");
    //           this.getToken();
    //           // window.location.href = "http://dudao.tianwangwatch.cn/OAuth";
    //         } else {
    //           this.storeData.userInfo.userName = data.data.name;
    //           this.storeData.userInfo.userId = data.data.id;
    //           this.storeData.userInfo.userLogo = data.data.headPhoto;
    //           this.storeData.userInfo.userStore = data.data.address;
    //           this.storeData.userInfo.userCity = data.data.city;
    //           if (
    //             data.data.positionName == "导购员" &&
    //             !data.data.birthday&&!data.data.workYear
    //           ) {
    //             this.$router.replace("/personInfo");
    //           }
    //         }
    //       })
    //       .catch(error => {
    //         console.log(error);
    //       });
    //     // }

    //     // 触发后台更新用户信息
    //     UpdataUserInfo().then(({ data }) => {
    //       console.log(data);
    //     });
    //   });

    /**
     * 走授权页面
     */
    if (!window.localStorage.getItem("_t")) {
      this.$router.replace({
        name: "oauth"
      });
    } else {
      // }
      var StartTime = Date.parse(new Date());
      console.log(StartTime);
      window.localStorage.setItem("startTime", StartTime);
      if (!window.localStorage.getItem("_t")) {
        this.$router.replace({
          name: "oauth"
        });
      } else {
        this.storeData.token = window.localStorage.getItem("_t");
        initUserData(this.storeData.token)
          .then(({ data }) => {
            console.log(data);
            if (data.code === 501) {
              localStorage.removeItem("_t");
              this.getToken();
              // window.location.href = "http://dudao.tianwangwatch.cn/OAuth";
            } else {
              this.storeData.userInfo.userName = data.data.name;
              this.storeData.userInfo.userId = data.data.id;
              this.storeData.userInfo.userLogo = data.data.headPhoto;
              this.storeData.userInfo.userStore = data.data.address;
              this.storeData.userInfo.userCity = data.data.city;
              this.storeData.userInfo.positionName = data.data.positionName;
              if (
                data.data.positionName == "导购员" &&
                !data.data.birthday&&!data.data.workYear
              ) {
                this.$router.replace("/personInfo");
              }
            }
          })
          .catch(error => {
            console.log(error);
          });
      }

      // 微信sdkJs注入
      getSign(window.location.href.split("#")[0]).then(data => {
        wx.config({
          // beta: true,// 必须这么写，否则wx.invoke调用形式的jsapi会有问题
          // debug: true, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
          appId: "ww5f1917dc1e451a6e", // 必填，企业微信的corpID
          timestamp: data.data.data.timestamp, // 必填，生成签名的时间戳
          nonceStr: data.data.data.noncestr, // 必填，生成签名的随机串
          signature: data.data.data.signature, // 必填，签名，见 附录-JS-SDK使用权限签名算法
          jsApiList: ["hideOptionMenu"] // 必填，需要使用的JS接口列表，凡是要调用的接口都需要传进来
        });
        wx.ready(function() {
          // config信息验证后会执行ready方法，所有接口调用都必须在config接口获得结果之后，config是一个客户端的异步操作，所以如果需要在页面加载时就调用相关接口，则须把相关接口放在ready函数中调用来确保正确执行。对于用户触发时才调用的接口，则可以直接调用，不需要放在ready函数中。
          wx.hideOptionMenu();
        });
        wx.error(function(error) {
          console.log("error", error);
        });
      });

      // 触发后台更新用户信息
      UpdataUserInfo().then(({ data }) => {
        console.log(data);
      });
    }

    if (navigator.userAgent.indexOf("Windows") !== -1) {
      document.body.style.maxWidth = "500px!important";
      document.body.style.position = "relative!important";
    }
    if (
      this.$route.path != "/course" &&
      this.$route.path !== "/" &&
      this.$route.path != "/assessment" &&
      this.$route.path != "/administration" &&
      this.$route.path != "/mine"
    ) {
      this.hideNav = true;
      this.$root.center.$emit("hideNav", this.hideNav);
    } else {
      this.hideNav = false;
      this.$root.center.$emit("hideNav", this.hideNav);
    }
    // 点击搜索时
    this.$root.center.$on("canShowCover", data => {
      this.showCover = data;
    });
    // 点击取消搜索时
    this.$root.center.$on("noShowCover", data => {
      this.showCover = data;
    });
    this.onlineTimer = setInterval(()=>{
      // var OutTime = Date.parse(new Date());
      // window.sessionStorage.setItem("outTime", OutTime);
      // var Time =
      //   (OutTime - Number(window.localStorage.getItem("startTime"))) /
      //   1000 /
      //   60;
      var params = {
        min: 1,
        id: this.storeData.userInfo.userId
      };
      GetOnlineTime(params).then(({ data }) => {
        console.log(data);
      });
    },60000)
  }
  // }
};
</script>

<style>
* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  -webkit-touch-callout: none; /*系统默认菜单被禁用*/
  -webkit-user-select: none; /*webkit浏览器*/
  -khtml-user-select: none; /*早起浏览器*/
  -moz-user-select: none; /*火狐浏览器*/
  -ms-user-select: none; /*IE浏览器*/
  user-select: none; /*用户是否能够选中文本*/
}
input {
  -webkit-touch-callout: auto !important; /*系统默认菜单被禁用*/
  -webkit-user-select: auto !important; /*webkit浏览器*/
  -khtml-user-select: auto !important; /*早起浏览器*/
  -moz-user-select: auto !important; /*火狐浏览器*/
  -ms-user-select: auto !important; /*IE浏览器*/
  user-select: auto !important; /*用户是否能够选中文本*/
}
html {
  width: 100%;
  height: 100%;
  -webkit-touch-callout: none; /*系统默认菜单被禁用*/
  -webkit-user-select: none; /*webkit浏览器*/
  -khtml-user-select: none; /*早起浏览器*/
  -moz-user-select: none; /*火狐浏览器*/
  -ms-user-select: none; /*IE浏览器*/
  user-select: none; /*用户是否能够选中文本*/
  background-color: rgb(240, 241, 242);
}
body {
  max-width: 500px;
  /* width: 100%; */
  height: 100%;
  position: relative;
  margin: auto;
  -webkit-touch-callout: none; /*系统默认菜单被禁用*/
  -webkit-user-select: none; /*webkit浏览器*/
  -khtml-user-select: none; /*早起浏览器*/
  -moz-user-select: none; /*火狐浏览器*/
  -ms-user-select: none; /*IE浏览器*/
  user-select: none; /*用户是否能够选中文本*/
  /* overflow: hidden; */
}
/* img{
  -webkit-user-select:none!important;
 	-webkit-touch-callout:none!important;
	user-select:none!important;
	-webkit-user-select:none!important;
	-ms-user-select:none!important;

	-moz-user-select:none!important;
	touch-callout:none!important;
	-webkit-touch-callout:none!important;
	-ms-touch-callout:none!important;
	-moz-touch-callout:none!important;
} */
/* img{
  pointer-events: none;
} */
#app {
  width: 100%;
  height: 100%;
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* background-color: #fff; */
}
.backTop{
  position: fixed;
  right: 10px;
  bottom: 20px;
  height: 50px;
  width: 50px;
  border-radius: 100%;
  overflow: hidden;
  cursor: pointer;
}
.backTop img{
  width: 100%;
}
#Cover {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 999999999;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: #eee;
  font-size: 10px;
  color: #333;
}
#Cover #CoverImg {
  width: 100px;
  /* height: 100px; */
  margin-bottom: 19px;
}
.van-dialog__message {
  font-size: 16px !important;
}
.headerTop {
  max-width: 500px;
  margin: auto;
  height: 44px;
  padding: 0 15px;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  color: #333;
  display: flex;
  z-index: 5;
  font-family: LucidaGrande-Bold;
  font-size: 16px;
  justify-content: space-between;
  align-items: center;
  background: #fff;
  border-bottom: 1px solid #eee;
}
.headerTop .header-left {
  cursor: pointer;
  padding-left: 15px;
  background: url(./assets/back.png) no-repeat left center;
  background-size: 10px 15px;
}
.headerTop .header-right {
  width: auto;
  padding: 0 10px;
  height: 30px;
  line-height: 30px;
  cursor: pointer;
  /* opacity:0.3; */
  font-family: PingFangSC-Regular;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.3);
  /* border-radius: 8px;
        background-color:bisque; */
}
.showClass {
  font-family: PingFangSC-Medium !important;
  color: #333 !important;
}
.van-dialog {
  max-width: 300px !important;
}
.wrantips{
  position: fixed;
  top: 0px;
  left: 0;
  right: 0;
  z-index: 9999999;
  height: 1rem;
  line-height: 1rem;
  font-size: 0.3rem;
  color: #fff;
  text-align: center;
  background-color: rgba(0, 0, 0, 0.3);
}
</style>


// WEBPACK FOOTER //
// src/App.vue